// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalendarCard_wrapper__1ml3A"};